export enum PageWithFiltersEnum {
    Violations,
    Dashboard,
    Inventory,
    Hygiene,
    Playbooks,
    Executions,
    Dashboards,
    AiActivity,
    AiFindings,
    AiDataInsights,
    Policies,
}
